export const getCoordinatesText: (coordinates: google.maps.LatLngLiteral, separator?: string) => string = (
	coordinates,
	separator = ', '
) => {
	return [coordinates.lat, coordinates.lng].join(separator)
}
